import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import SearchBar from "@/components/feature/SearchBar";

const NAV_ITEMS = [
  { to: "/", label: "首页", icon: "ri-home-5-line", end: true },
  { to: "/category/movie", label: "电影", icon: "ri-film-line", end: false },
  { to: "/category/tv", label: "电视剧", icon: "ri-tv-2-line", end: false },
  { to: "/about", label: "关于", icon: "ri-information-line", end: false },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.search]);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="flex h-16 items-center gap-3 px-4 md:gap-8 md:px-6">
        <Link to="/" className="flex shrink-0 items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-lg text-background-50">
            <i className="ri-closed-captioning-line"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-base font-bold text-foreground-950 md:text-lg">
              最近中文字幕
            </span>
            <span className="hidden text-xs text-foreground-400 sm:block">
              最新影视资源 · 字幕更新
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `flex items-center gap-1.5 whitespace-nowrap rounded-md px-3 py-2 text-sm transition-colors ${
                  isActive
                    ? "bg-primary-100 font-medium text-primary-700"
                    : "text-foreground-600 hover:bg-background-100 hover:text-foreground-900"
                }`
              }
            >
              <i className={item.icon}></i>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="ml-auto hidden w-[300px] md:block">
          <SearchBar />
        </div>

        <button
          type="button"
          onClick={() => setMenuOpen((prev) => !prev)}
          aria-label={menuOpen ? "关闭导航菜单" : "打开导航菜单"}
          aria-expanded={menuOpen}
          className="ml-auto flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-xl text-foreground-700 md:hidden"
        >
          <i className={menuOpen ? "ri-close-line" : "ri-menu-line"}></i>
        </button>
      </div>

      <div className="px-4 pb-3 md:hidden">
        <SearchBar />
      </div>

      {menuOpen && (
        <nav className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <ul className="flex flex-col gap-1">
            {NAV_ITEMS.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  end={item.end}
                  className={({ isActive }) =>
                    `flex items-center gap-3 rounded-md px-3 py-3 text-sm ${
                      isActive
                        ? "bg-primary-100 font-medium text-primary-700"
                        : "text-foreground-700 hover:bg-background-100"
                    }`
                  }
                >
                  <span className="flex h-8 w-8 items-center justify-center rounded-md bg-background-100 text-base">
                    <i className={item.icon}></i>
                  </span>
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      )}
    </header>
  );
}